<template>
  <div>
    <Tabs :v-model="mode" @on-click="tabChange" ref="tabs">
      <TabPane label="收货地址" name="list" ref="list" id="list"></TabPane>
      <TabPane label="编辑/新增" name="edit" ref="edit"></TabPane>
    </Tabs>
    <div v-if="mode === 'list'">
      <Table :columns="columns" :data="list"></Table>
    </div>
    <div v-show="mode === 'edit'">
      <Form ref="form" :model="params" :rules="rule" inline :label-width="100">
        <FormItem prop="name" label="收货人:" class="fromitem">
          <Input v-model="params.name" type="text" placeholder="填写收货人姓名"></Input>
        </FormItem>
        <FormItem prop="phone" label="手机号码:" class="fromitem">
          <Input v-model="params.phone" type="text" placeholder="填写收货人联系电话"></Input>
        </FormItem>
        <FormItem prop="areaArr" label="所在地区:" class="fromitem">
          <al-selector :gutter="0" data-type="name" searchable v-model="params.areaArr" level="2" />
        </FormItem>
        <FormItem prop="address" label="详细地址:" class="fromitem">
          <Input v-model="params.address" type="text" placeholder="填写详细收货地址"></Input>
        </FormItem>
        <FormItem prop="label" label="标签:" class="fromitem">
          <Input v-model="params.label" type="text"></Input>
        </FormItem>
      </Form>
      <div class="footer" style="text-align: right;">
        <Button style="margin-right:10px" @click="tabChange('list')">取消</Button>
        <Button type="primary" @click="save">确定</Button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    UserId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      mode: "list",
      params: {
        id: 0,
        name: "",
        phone: "",
        province: "",
        area: "",
        city: "",
        address: "",
        is_default: 0,
        label: "",
        areaArr: []
      },
      rule: {
        areaArr: [
          {
            required: true,
            message: "请选择所在地区",
            type: "array",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请选择所在地区",
            trigger: "blur"
          }
        ],
        phone: [
          {
            required: true,
            message: "请选择所在地区",
            trigger: "blur"
          }
        ],
        address: [
          {
            required: true,
            message: "请选择所在地区",
            trigger: "blur"
          }
        ]
      },
      list: [],
      columns: [
        {
          title: "姓名",
          key: "name",
          width: 90
        },
        {
          title: "电话",
          key: "phone",
          width: 120
        },
        {
          title: "所在地区",
          key: "area",
          width: 150,
          render: (h, data) => {
            return h(
              "Tooltip",
              {
                style: {
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                },
                props: {
                  content: `${data.row.province}-${data.row.area}-${data.row.city}`,
                  placement: "top"
                }
              },
              `${data.row.province}-${data.row.area}-${data.row.city}`
            );
          }
        },
        {
          title: "详细地址",
          key: "address",
          width: 150,
          render: (h, data) => {
            return h("p", {}, data.row.address);
          }
        },
        {
          title: "是否默认",
          key: "is_default",
          width: 100,
          render: (h, data) => {
            return h("p", {}, data.row.is_default ? "是" : "否");
          }
        },

        {
          title: "标签",
          key: "label",
          width: 100
        },
        {
          title: "操作",
          key: "action",
          width: 80,
          fixed: "right",
          render: (h, data) => {
            if (this.$CheckShow(this.$route.name, "EDIT")) {
              return [
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.tabChange("edit", data.row);
                      }
                    }
                  },
                  "编辑"
                )
              ];
            }
          }
        }
      ]
    };
  },
  mounted() {},
  created() {
    this.getUserAddress();
  },
  methods: {
    ...mapActions(["GetUserAddress", "SaveUserAddress"]),
    getUserAddress() {
      this.GetUserAddress({ user_id: this.UserId }).then(res => {
        this.list = res.data;
      });
    },
    tabChange(e, params = null) {
      this.params = {
        id: 0,
        name: "",
        phone: "",
        province: "",
        area: "",
        city: "",
        address: "",
        is_default: 0,
        label: "",
        areaArr: []
      };
      if (e === "list") {
        this.$refs.tabs.activeKey = "list";
      } else if (e === "edit" && params) {
        params.areaArr = [params.province, params.area, params.city];
        this.params = params;
      }
      this.mode = e;
    },
    save() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        if (this.params.areaArr.length < 3) {
          this.$Message.error("请选择完整的地区");
          return false;
        }
        let data = {
          id: this.params.id,
          name: this.params.name,
          phone: this.params.phone,
          province: this.params.areaArr[0],
          area: this.params.areaArr[1],
          city: this.params.areaArr[2],
          address: this.params.address,
          is_default: 0,
          label: this.params.label,
          user_id: this.UserId
        };
        this.SaveUserAddress(data).then(res => {
          if (!res.status) {
            this.$Message.error(res.msg);
            return false;
          }
          this.getUserAddress();
          this.tabChange('list',false);
          this.$Message.success(res.msg);
        });
      });
    }
  },
  computed: mapGetters({}),
  watch: {
    UserId(n, o) {
      this.getUserAddress();
    }
  }
};
</script>
<style lang='less' >
.footer {
  border-top: 1px solid #e8eaec;
  padding: 12px 0 0 0;
}
.fromitem {
  width: 95%;
}
@import "./index.less";
</style>
